var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHansumImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 71,
    viewBox: "0 0 67 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x9E\x90\xEC\x82\xB0 18 1",
    clipPath: "url(#clip0_1515_10644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0308 8.2607C24.3165 14.055 19.7104 18.7531 14.0295 15.4018C8.34861 18.7531 3.74249 14.055 7.02819 8.2607C3.73865 2.46638 8.34478 -2.23172 14.0295 1.11959C19.7104 -2.23172 24.3165 2.46638 21.0308 8.2607Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0295 10.7858C15.3968 10.7858 16.5053 9.65522 16.5053 8.26058C16.5053 6.86593 15.3968 5.73535 14.0295 5.73535C12.6622 5.73535 11.5537 6.86593 11.5537 8.26058C11.5537 9.65522 12.6622 10.7858 14.0295 10.7858Z",
    fill: "#F8ECE8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.7203 70.9999H4.28001C1.5125 70.9999 -0.525715 68.3611 0.119143 65.6206L4.6178 46.4523C7.81522 32.8278 19.7604 23.2163 33.4982 23.2163C47.236 23.2163 59.1774 32.8239 62.3787 46.4523L66.8773 65.6206C67.5222 68.365 65.484 70.9999 62.7164 70.9999H62.7203Z",
    fill: "#A9C5E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.4392 43.2106C27.4356 43.2106 28.2433 42.0835 28.2433 40.6932C28.2433 39.3029 27.4356 38.1758 26.4392 38.1758C25.4428 38.1758 24.6351 39.3029 24.6351 40.6932C24.6351 42.0835 25.4428 43.2106 26.4392 43.2106Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.5608 43.234C41.5571 43.234 42.3648 42.1069 42.3648 40.7166C42.3648 39.3263 41.5571 38.1992 40.5608 38.1992C39.5644 38.1992 38.7567 39.3263 38.7567 40.7166C38.7567 42.1069 39.5644 43.234 40.5608 43.234Z",
    fill: "#25569D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.5019 46.7262C34.3286 46.7262 34.9989 46.2267 34.9989 45.6104C34.9989 44.9942 34.3286 44.4946 33.5019 44.4946C32.6751 44.4946 32.0049 44.9942 32.0049 45.6104C32.0049 46.2267 32.6751 46.7262 33.5019 46.7262Z",
    fill: "#F8ECE8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22.4741 57.211C22.1248 57.211 21.7793 57.0504 21.5528 56.7411C21.1728 56.2243 21.2726 55.4883 21.7831 55.1007C21.8753 55.0303 23.9979 53.3742 23.806 50.8176C23.6563 48.8679 22.2783 47.6425 21.8561 47.3136C21.3532 46.9182 21.2573 46.1822 21.645 45.6693C22.0326 45.1564 22.7543 45.0585 23.2571 45.454C23.8674 45.9316 25.8749 47.7208 26.0976 50.6375C26.3854 54.396 23.4951 56.7255 23.165 56.976C22.9577 57.1326 22.7159 57.211 22.4741 57.211Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.5259 57.211C44.2841 57.211 44.0423 57.1326 43.835 56.976C43.5049 56.7216 40.6146 54.396 40.9025 50.6375C41.1251 47.7208 43.1326 45.9316 43.7429 45.454C44.2457 45.0585 44.9674 45.1564 45.355 45.6693C45.7427 46.1822 45.6468 46.9182 45.1439 47.3136C44.7255 47.6425 43.3437 48.8679 43.194 50.8176C42.9982 53.3742 45.1247 55.0303 45.2169 55.1007C45.7235 55.4883 45.8272 56.2243 45.4472 56.7411C45.2207 57.0465 44.8752 57.211 44.5259 57.211Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.4021 53.6519C33.1449 53.6519 32.8877 53.648 32.6229 53.6363C28.2586 53.4366 25.5333 51.7022 24.566 50.9623C24.0555 50.5747 23.9518 49.8387 24.3318 49.3219C24.7119 48.8012 25.4373 48.6955 25.9402 49.083C26.5658 49.5568 28.8958 51.1189 32.7265 51.2951C37.7434 51.5221 40.9216 49.1105 41.0559 49.0087C41.5626 48.6132 42.2804 48.715 42.6681 49.2279C43.0519 49.7408 42.956 50.4768 42.4531 50.8722C42.0731 51.1698 38.7183 53.6559 33.4059 53.6559L33.4021 53.6519Z",
    fill: "#25569D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.2601 25.3146C33.1871 25.3146 33.1142 25.3068 33.0413 25.295C32.4156 25.1737 32.0087 24.559 32.1277 23.9208C32.4425 22.2413 32.6997 18.9487 30.8495 15.7501C28.7307 12.0934 24.6044 9.88527 20.0251 10.0262C19.4455 9.99881 18.8621 9.53291 18.8429 8.88692C18.8275 8.24093 19.3265 7.70065 19.9599 7.68108C25.3913 7.55579 30.2853 10.1632 32.8302 14.556C35.0641 18.4201 34.7647 22.3587 34.3886 24.3593C34.2811 24.9192 33.8013 25.3107 33.2601 25.3107V25.3146Z",
    fill: "#25569D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1515_10644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHansumImg);
export default __webpack_public_path__ + "static/media/hansum_img.e975fc3c3b4ed92c29b4c449e068cef4.svg";
export { ForwardRef as ReactComponent };